import React, { useState, useEffect,} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import { GpsBaseURL, Role } from '../../api/DataApis';
import { Link, Navigate, useParams } from 'react-router-dom';
import request from '../../Apis/request';
import "./User.css";
import ReactPaginate from 'react-paginate'; 
import { GrTransaction } from 'react-icons/gr';
import Loader from "../Settings/Loader";
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';



  const PlacedOrder = () => {
  const [corporateData, setCorporateData] = useState([]);
   const [selectedCorporate, setSelectedCorporate] = useState("");
   const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatusType, setSelectedStatusType] = useState("0");
  const [userStatuses, setUserStatuses] = useState({});
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); 
  const [selectedUser, setSelectedUser] = useState('');
  const [popupInput, setPopupInput] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [Limit, setLimit] = useState({});
  const [currentPage, setCurrentPage] = useState(1); 
  const [selectStatusType, setselectedStatusType] = useState("");
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [Isorder, setIsOrder] = useState(false);
  const [selectOrders, setselectOrders] = useState([]);
   const [isgeneration, setisgeneration] = useState("");
   const [isloading, setIsLoading] = useState(false);
   const [Status, setStatus] = useState("");
   const [hasExcel, sethasExcel] =  useState("");
   
  const [showModal, setShowModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);


  const [searchTerms, setSearchTerms] = useState({
    srNo: '',
    name: '',
    email: '',
    phone: '',
    meterTransactions: '',
    rfids: '',
    wallet: '',
    status: '',
    createdDate: '',
    actions: ''
  });

// Inline modal styles
const modalStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 999,
};

const modalContentStyle = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "10px",
  width: "400px",
};


const handleUpdateOrder = async () => {
  // ✅ Step 1: Validation
  if (!selectedCorporate) {
    Swal.fire({
      icon: "error",
      title: "Validation Error",
      text: "Please select a corporate before updating!",
    });
    return;
  }

  // ✅ Step 2: Show confirmation dialog
  const confirmResult = await Swal.fire({
    title: "Are you sure?",
    text: "Do you really want to update this order?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, update it!",
    cancelButtonText: "Cancel",
  });

  // ✅ If user cancelled, stop here
  if (!confirmResult.isConfirmed) {
    return;
  }

  // ✅ Step 3: Show loader while API is running
  Swal.fire({
    title: "Updating Order...",
    text: "Please wait",
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  try {
    // ✅ Step 4: API call
    const response = await axios.post(
      `${GpsBaseURL}/order/update-order`,
      {
        corporate_id: selectedCorporate,
        order_id: selectedOrderId,
      },
      {
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
      }
    );

    // ✅ Step 5: Close loader and show success message
    Swal.close();
    Swal.fire({
      icon: "success",
      title: "Success!",
      text: "Order updated successfully!",
      showConfirmButton: false,
      timer: 1500,
    });

    // Reset state
    setShowModal(false);
    setSelectedCorporate("");
  } catch (error) {
    // ✅ Step 6: Handle errors
    Swal.close();

    console.error("Error updating order:", error);
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: error.response?.data?.message || "Failed to update order. Please try again.",
    });
  }
};



  const handleCheckboxChange = (orderId) => {
    setSelectedOrders((prevSelected) => {
      if (prevSelected.includes(orderId)) {
        return prevSelected.filter((id) => id !== orderId);
      } else {
        return [...prevSelected, orderId];
      }
    });
  };
  const handleorderCheckboxChange = (orderId) => {
    setselectOrders((prevSelected) => {
      if (prevSelected.includes(orderId)) {
        return prevSelected.filter((id) => id !== orderId);
      } else {
        return [...prevSelected, orderId];
      }
    });
  };


  // Modal open
  const openUpdateModal = (orderId, corporate_id) => {
    console.log("corporate_id", corporate_id);
    setSelectedOrderId(orderId);
    setSelectedCorporate(corporate_id);
    setShowModal(true);
  };

  // const handleSelectAll = () => {
  //   console.log("selectedOrders.lengthall", selectedOrders.length,"filteredData.lengthall", filteredData.length );
  //   if (selectedOrders.length === filteredData.length) {
  //     setSelectedOrders([]); // Uncheck all
  //   } else {
  //     setSelectedOrders(filteredData.map((user) => user?.user_order_id)); // Select all
  //   }
  // };
  // Derive IDs for the current page from filteredData
const currentPageOrderIds = filteredData.map((user) => user.user_order_id);

// Determine which IDs on the current page are selected
const selectedOrdersOnPage = selectedOrders.filter((id) =>
  currentPageOrderIds.includes(id)
);

// "Select All" checkbox is checked if every order on this page is selected
const isAllSelected = selectedOrdersOnPage.length === filteredData.length && filteredData.length > 0;

const handleSelectAll = () => {
  if (isAllSelected) {
    // Remove current page orders from the global selected orders
    setSelectedOrders(selectedOrders.filter((id) => !currentPageOrderIds.includes(id)));
  } else {
    // Add all orders from the current page (avoiding duplicates)
    const newSelected = [...selectedOrders];
    currentPageOrderIds.forEach((id) => {
      if (!newSelected.includes(id)) {
        newSelected.push(id);
      }
    });
    setSelectedOrders(newSelected);
  }
};

  const handleSelectAllOrders = () => {
    console.log("selectedOrders.length", selectedOrders.length,"filteredData.length", filteredData.length );
    if (selectOrders.length === filteredData.length) {
      setselectOrders([]); // Uncheck all
    } else {
      setselectOrders(filteredData.map((user) => user?.user_order_id)); // Select all
    }
  };

  let navigate = useNavigate();
  const handleSearch = (column, value) => {
    setSearchTerms((prev) => ({
      ...prev,
      [column]: value
    }));
  };

  const handleReset = (event) => {
    event.preventDefault()
   navigate(`/orders/placed-orders-list`);
    }
 document.title = "Placed Order";

 const corporateOptions = corporateData.map(corporate => ({
  value: corporate._id,
  label: `${corporate.corporate_name} (${corporate?.email})`,
  _id: corporate._id,
}));

const handlecorporateChange = (selectedOption) => {
  console.log("selectedOption3wrewgfreh", selectedOption);
  if(selectedOption) {
 setSelectedCorporate({ id: selectedOption._id });
  } else {
    setSelectedCorporate(null);
  }
}
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const fetchproducts = async (page) => {
    //alert(page);
    setLoadings(true);
    
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/order`);
   
    
    // Prepare query parameters
    const queryParams = [`page=${page}`];
    
    // Add search term to the query params if it's not empty
   
    if (searchQuery) queryParams.push(`searchText=${searchQuery}`);
     queryParams.push(`status=Placed`);
    if(selectedCorporate?.id) queryParams.push(`corporate_id=${selectedCorporate?.id}`);
    if(Status) queryParams.push(`status=${Status}`);
    if(hasExcel) {queryParams.push(`type=${hasExcel}`);}
    const apiUrl = `${apiEndpoint}?${queryParams.join('&')}`;
  
    try {
      const data = {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      };

      if( hasExcel == "excel" ) {
        data.responseType = "blob";
      }

      const response = await axios.get(apiUrl, data);



if( hasExcel == "excel" ) {
  // Convert response to blob (response.data contains the blob)
  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  
  // Create a download link
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "OrderList.xlsx"; // File name for download
  document.body.appendChild(a);
  a.click();
  sethasExcel("");
  // Cleanup
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);

  return ;
}
     
      //setSelectedOrders([]);
      setFilteredData(response.data?.data);
      setTotalCount(response.data.totalCount || 0);
      setLimit(response?.data?.limit);
      setPageCount(Math.ceil(response.data.totalCount / response?.data?.limit)); // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadings(false);
    }
  };
  
  // Re-fetch users whenever searchTerm changes
  useEffect(() => {
    fetchproducts(page);
  }, [searchTerm,  page, hasExcel]);
  


  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };
  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  const handleDownload = (event) => {
    event.preventDefault()
    sethasExcel("excel");
    }

  
  const fetchCorporatesData = async () => {
   
    const apiEndpoint = `${GpsBaseURL}/corporate`;
    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      console.log("Countries response", response);
      setCorporateData(response.data.data);
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
     
    }
  };
useEffect(() => {
    if (Role === "false") {
      fetchCorporatesData();  // Only fetch corporate data if Role === "false"
    }
  }, [Role]);
  
  
 const handleSearchTextChange = (e) => {
  setSearchQuery(e.target.value);
};

// Handle submit to fetch filtered data
const handleSearchSubmit = async (e) => {
  e.preventDefault(); // Prevent default form submission

  const page = 1; // Always reset to page 1 when searching
  setPage(page); // Ensure pagination resets to the first page

  // Set loading to true while fetching
  setLoadings(true); 

  // Prepare the base URL and query parameters
  let url = `${GpsBaseURL}/order/?page=${page}`;
  //let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/product/`);
  const params = [];
  params.push(`status=Placed`);
  // Add search term if present
  if (searchQuery.trim()) {
      params.push(`searchText=${searchQuery}`);
  }
  if (selectedCorporate?.id) {
    params.push(`corporate_id=${selectedCorporate?.id}`);
}

  //
    // params.push(`status=Placed`);
  if (params.length) {
      url += `&${params.join('&')}`;
  }

  try {
      const res = await axios.get(url, {
          headers: {
              Authorization: `Bearer ${uniqueToken}`, // Include authorization token
          },
      });

      if (res && res?.data && res?.data?.data) {
          setFilteredData(res?.data?.data); // Update filtered data
          setTotalCount(res?.data?.data?.length); // Set total count based on the filtered data length
          setPageCount(Math.ceil(res?.data?.totalCount / res?.data?.limit)); // Update page count based on results
      } else {
          setFilteredData([]); // If no data is returned, set filtered data to empty
          setTotalCount(0); // If no data is returned, set totalCount to 0
      }
      
  } catch (error) {
      console.error("Error fetching filtered data:", error);
  } finally {
      setLoadings(false); // Set loading to false after fetching
  }
};

const handleSelectChange = async (meter) => {
  console.log("meterrr", meter);
  
  try {
    Swal.fire({
      title: 'Processing...',
      text: 'Please wait...',
      allowOutsideClick: false,
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      didOpen: () => {
        // Swal.showLoading();
      },
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'The operation was cancelled', 'error');
      }
    });

    Swal.close();
    
    Swal.fire({
      allowOutsideClick: false,
      width: '50%',
      html: `
        <div style="max-width: 100%; overflow-x: auto;">
          <div style="font-weight: bold; margin-bottom: 10px; border: 2px solid #ccc; padding: 10px; border-radius: 5px;">
            <h4>Product Items</h4>
          </div>
          <table style="table-layout: auto; width: 100%; border-collapse: collapse; font-size: 14px; text-align: left;" border="1">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th>Product Image </th>
                <th>Product Name</th>
               <th>Quantity</th>
                 <th>Price</th>
             </tr>
            </thead>
          <tbody>
      ${
        meter.items?.length > 0 ? 
        meter.items.map((log, index) => {
          return `
            <tr>
              <td>${index + 1}</td>
              <td><img src="${log.product_image}" alt="${log.product_name}" style="max-width: 50px; height: auto;"></td>
              <td>${log?.product_name}</td>
              <td>${log?.quantity}</td>
              <td>${log?.price}
           
         
            </tr>
          `;
        }).join('') : 
        ``
      }
    </tbody>
          </table>
        </div>
      `,
      showCloseButton: true,
      showConfirmButton: false
    });
  } catch (error) {
    console.error('Error:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Something went wrong.',
    });
  }
};
const handleDownloadInvoice = async (e) => {
  e.preventDefault();
  const selectedValue = e.target.value;
  setisgeneration(true);  // Set generation to true when the process starts
  setIsOrder(true);
  setIsLoading(true);  // Start showing the loader inside the button

  // Check if any orders are selected
  if (selectedOrders.length === 0) {
    alert("Please select at least one order.");
    setIsOrder(false);
    setIsLoading(false);  // Stop showing the loader if no orders are selected
    return;
  }

  // Show Swal modal to get Title and Comment before continuing
  Swal.fire({
    title: 'Enter details',
    html: `
    <div id="select-product-container" style="margin-bottom: 10px;"></div>

    <div style="display: flex; flex-direction: column; align-items: flex-start;">
      <label for="titleInput" style="font-weight: bold; text-align: left; width: 100%;">Title</label>
      <input id="titleInput" class="form-control" placeholder="Enter Title" 
            style="width: 100%; padding: 8px; margin-top: 5px; border-radius: 5px; border: 1px solid #ccc; text-align: left;">
      
      <label for="commentInput" style="margin-top: 10px; font-weight: bold; text-align: left; width: 100%;">Comment</label>
      <textarea id="commentInput" class="form-control" placeholder="Enter Your Comment" 
                style="width: 100%; padding: 8px; margin-top: 5px; border-radius: 5px; border: 1px solid #ccc; height: 85px; text-align: left;"></textarea>
    </div>

  
  `,
  showCancelButton: true,
  confirmButtonColor: "#3085d6",
  cancelButtonColor: "#d33",
  confirmButtonText: `<span id="swal-confirm-text">Yes, Send it!</span>`,
  cancelButtonText: "No, cancel!",
  showLoaderOnConfirm: true, // Show the loader on confirmation click
  allowOutsideClick: false,  // Prevent clicking outside while loading
  allowEscapeKey: false,     // Prevent closing the modal on escape key
  preConfirm: () => {
    const title = document.getElementById('titleInput').value;
    const comment = document.getElementById('commentInput').value;

    // Show Loader in Button and disable button
    Swal.getConfirmButton().innerHTML = `<i class="fa fa-spinner fa-spin"></i> Sending...`;
    Swal.getConfirmButton().disabled = true;

    if (!title || !comment) {
      Swal.showValidationMessage('Title and Comment are required!');
      return false; // Prevent submission if validation fails
    }

    // Return the title and comment as part of the result object
    return { title, comment };
  }
}).then(async (result) => {
  if (!result.isConfirmed) {
    setIsOrder(false);
    setIsLoading(false);  // Stop showing the loader if the user cancels
    return;
  } // If user cancels, exit

  const { title, comment } = result.value; // Get title and comment values

  // Handle the request depending on the selected value (Generate PDF or Generate Label)
  try {
    let response;
    let apiUrl;
    let bodyData = { orderIds: selectedOrders, title, comment };

    // Determine the API endpoint based on selected value
    if (selectedValue === 'generate_pdf') {
      apiUrl = `${GpsBaseURL}/order/invoice-generate`;
    } else if (selectedValue === 'generate_label') {
      apiUrl = `${GpsBaseURL}/order/generate-awb`;
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Selection',
        text: 'The selected option is not valid.',
      });
      setIsOrder(false);
      setIsLoading(false);  // Stop showing the loader if there's an invalid selection
      return;
    }

    // Send the request to generate invoice or label
    response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${uniqueToken}`, // Authorization token
      },
      body: JSON.stringify(bodyData),
    });

    if (!response.ok) {
      throw new Error('Something went wrong while generating the invoice/label.');
    }

    const data = await response.json();
if(data?.statusCode ===200) {
  navigate(`/orders/shippment-logs`);
  return;
}

    const message = data?.message || 'Generation successful';
    // const responseUrl = selectedValue === 'generate_pdf'
    //   ? data?.data?.response?.invoice_url
    //   : data?.data?.response?.label_url;

    // Handle errors if URL is not returned
    if (data?.statusCode !== 200) {
      Swal.fire({
        icon: 'error',
        title: 'Generation Failed',
        text: 'Invoice/Label URL not found.',
      });
      setIsOrder(false);
      setIsLoading(false);  // Stop the loader if URL not found
      return;
    }

    // Handle success and trigger file download
    // const link = document.createElement('a');
    // link.href = responseUrl;
    // link.download = selectedValue === 'generate_pdf' ? 'invoice.pdf' : 'label.pdf';
    // link.click(); // Programmatically click the link to start the download

    Swal.fire({
      icon: 'success',
      title: message,
      text: 'The file is being downloaded.',
    });

    setIsOrder(false); // Reset loading state after download
    setIsLoading(false); // Stop loader once the download is initiated
    return;
  } catch (error) {
    console.error("Error generating invoice/label:", error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Error generating invoice/label. Please try again.',
    });
    setIsOrder(false); // Reset loading state in case of error
    setIsLoading(false); // Stop the loader in case of error
  }
});
};







const array = ["a", "b", "c"]
const b = JSON.stringify(array);
for( let i=array.length-1; i>= 0; i-- ) {
  console.log(array[i]);
}

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  <div className="d-flex align-items-center">
    <h4 className="mb-0 me-3">All Placed Orders({totalCount ? totalCount : "Loading..." })</h4> {/* Add margin to the right of the heading */}
   
  </div>
  

</div>
<hr style={{ marginTop: "0px" }} />
<div className="row">
  <form className="form-horizontal" role="form" style={{ marginTop: "5px" }}>
    <div
      className="row px-3"
      style={{
        display: "flex",
        alignItems: "center",
        //gap: "10px", // Consistent spacing between filters
        flexWrap: "wrap", // Allow wrapping on smaller screens
      }}
    >
<div className="col-md-2 col-sm-12">
  <div className="form-group">
  <input
    placeholder="Find Data Here"
    className="form-control"
    style={{
      //width: "calc(100% - 150px)", // Increased available width for the input box
      borderRadius: "8px",
      padding: "6px 10px",
      marginRight: "10px",
      height: "38px", // Consistent height
    }}
    value={searchQuery}
    onChange={handleSearchTextChange}
  />
  </div>
</div>
{Role === "false" && (
<div className="col-md-2 col-sm-12"style={{alignItems: "center"}}>
  <div className="form-group">
    <Select
      options={corporateOptions}
      onChange={handlecorporateChange}
      value={corporateOptions?.find(option => option.value === selectedCorporate?.id) || null}
      placeholder="Corporate"
      isClearable
    
      styles={{
        control: (base) => ({
          ...base,
          height: '38px', 
          width: '100%', // Make width responsive
          boxShadow: 'none',
          minWidth: '0', // Ensures it can shrink below 165px if needed
          flex: 1, // Allow select to grow and shrink
        }),
      }}
    />
  </div>
</div>
)}
<div className="col-md-2 col-sm-12" style={{ display: "flex", alignItems: "center" }}>



    {/* Search Button */}
    <button
      className="btn btn-primary"
      onClick={handleSearchSubmit} // Calls the handleSearchSubmit function
      style={{
        marginLeft: "10px", // Space between the input and button
        height: "38px", // Consistent height
        width: "80px", // Consistent width for the Search button
        display: "flex", // Enable flexbox for centering
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: 0, // Ensure no extra padding that could offset centering
      }}
    >
      Search
    </button>

    {/* Reset Button */}
    <button
      className="btn btn-primary"
      onClick={handleReset} // Calls the handleReset function
      style={{
        marginLeft: "10px", // Space between the buttons
        height: "38px", // Consistent height
        width: "80px", // Slightly smaller width for Reset button
        display: "flex", // Enable flexbox for centering
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: 0, // Ensure no extra padding that could offset centering
      }}
    >
      Reset
    </button>
    <button
      className="btn btn-primary"
      onClick={handleDownload} // Calls the handleReset function
      style={{
        marginLeft: "10px", // Space between the buttons
        height: "38px", // Consistent height
        width: "80px", // Slightly smaller width for Reset button
        display: "flex", // Enable flexbox for centering
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: 0, // Ensure no extra padding that could offset centering
      }}
    >
      Download
    </button>
    
    {selectedOrders.length>0 &&  (
       <div className="col-md-2 col-sm-12" style={{ display: "flex", alignItems: "center" }}>
       <select
         className="form-control"
         style={{
           height: "38px",
           // border: "1px solid black",
           // borderRadius: "34px",
           maxWidth: "200px",
           minWidth: "120px",
         }}
         onChange={handleDownloadInvoice}
       >
         <option value="">Select Option</option>
         <option value="generate_pdf">Generate PDF</option>
         <option value="generate_label">Generate AWB</option>
       </select>
   </div>


)}
{/* {Isorder && (
  <div className="spinner-border"/>
)} */}
</div>
</div>
  </form>
</div>



              <div className="card-body" style={{ marginLeft: "-19px" }}>
  {loadings ? (
    <Loader /> 
  ) : totalCount === 0 ? (
    <div className="text-center">
      <h5>No User Data Found</h5> {/* Message to indicate no data found */}
    </div>
  ) : (
    <>
    <div className="table-responsive">
      <table
        className="display dataTable"
        id="advance-1"
        style={{ tableLayout: 'auto', width: '100%', borderCollapse: 'collapse' }}
      >
       <thead>
  <tr>
  <th>
  <input
                type="checkbox"
                onChange={handleSelectAll}
                checked={isAllSelected}
              />
            </th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Sr No</th>
    {Role ==="false" && (
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Corporate Name</th>
  )}
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Email</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Mobile</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>OrderID</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Total Price</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Payment ID</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Shipment ID</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Payment Status</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Status</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Order Date</th>
    <th style={{ minWidth: '200px', whiteSpace: 'nowrap' }}>Action</th>
    
    {/* <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Action<input type ="checkbox" onChange={handleSelectAllOrders}checked={selectOrders?.length === filteredData.length && filteredData.length > 0}></input></th> */}
   
  
 
  </tr>
</thead>

        <tbody> 
          {filteredData?.map((user, index) => (
            <tr key={index}>
              <td>
              <input
                  type="checkbox"
                  checked={selectedOrders.includes(user?.user_order_id)}
                  onChange={() => handleCheckboxChange(user?.user_order_id)}
                />
              </td>

              <td>{(page - 1) * Limit + index + 1}</td>
              {Role ==="false" &&  (
         <td>{user?.corporate_name}</td>
        )}
       <td>{user?.email}</td>
       <td>{user?.mobile}</td>
       <td>  <Link to=""
                                      title="Meter Transaction Logs"
                                      className="transaction-links"   // Specify the route if needed, or leave empty if not using routing
                                      onClick={(e) => {
                                        e.preventDefault();  // Prevents the default link behavior
                                        handleSelectChange(user);
                                      }}
                                    >{user?.orderId}  </Link></td>
                                    <td>{user?.total_price}</td>
                                    <td>{user?.payment_id}</td>
                                    <td>{user?.shipment_id}</td>
                                    <td> <button
    style={{
      width: "106px",
      textAlign: "center",  // Ensures horizontal centering
      padding: "5px",
      fontSize: "12px",
      display: "flex",        // Makes the button a flex container
      justifyContent: "center", // Centers content horizontally
      alignItems: "center",     // Centers content vertically
      backgroundColor: 
        user?.payment_status === 'Pending' ? 'yellow' :
        user?.payment_status === 'Success' ? 'Green' :
        user?.payment_status === 'Failed' ? 'Red' : "purple"
          // Default color
    }}
    className="btn"
  >
    {user?.payment_status}
  </button></td>
       <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
  <button
    style={{
      width: "106px",
      textAlign: "center",  // Ensures horizontal centering
      padding: "5px",
      fontSize: "12px",
      display: "flex",        // Makes the button a flex container
      justifyContent: "center", // Centers content horizontally
      alignItems: "center",     // Centers content vertically
      backgroundColor: 
      user?.status === 'Pending' ? 'yellow' :
      user?.status === 'Cancelled' ? 'Red' :
      user?.status === 'Placed' ? 'green' :
       user?.status ===  'Shipped' ? 'Orange' : "Purple",  // Default color
    }}
    className="btn"
  >
    {user?.status}
  </button>
</td>
       <td>{user?.orderDate}</td>
    <td> &nbsp;&nbsp;&nbsp;&nbsp;
            <Link to={`/orders/view-order/${user?.user_order_id}`} state={{ OrderEditData: user }}>
              <i className="fa fa-eye"
                title="Edit User"
              ></i>
            </Link>
                          
            &nbsp;&nbsp;
            <button
              className="btn btn-primary btn-sm"
              onClick={() => openUpdateModal(user?.orderId, user?.corporate_id)}
            >
              Update Order
            </button>                    
                          
      </td>
  </tr>
          ))}   
        </tbody>
      </table>
      {/* Popup Modal */}
      {showModal && (
        <div className="modal" style={modalStyle}>
          <div className="modal-content" style={modalContentStyle}>
            <h4>Update Order</h4>

            <label>Select Corporate:</label>
            <select
              value={selectedCorporate}
              onChange={(e) => setSelectedCorporate(e.target.value)}
              className="form-control"
            >
              <option value="">-- Select Corporate --</option>
              {corporateData?.map((corp) => (
                <option key={corp._id} value={corp._id}>
                  {corp.corporate_name}
                </option>
              ))}
            </select>

            <div style={{ marginTop: "15px", textAlign: "right" }}>
              <button
                className="btn btn-secondary"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              &nbsp;
              <button className="btn btn-success" onClick={handleUpdateOrder}>
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
</div>
    <div className="pagination-container mt-4">
        <ReactPaginate
          previousLabel={'Previous'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          forcePage={page - 1} 
        />
      </div>
    </>
  )}
</div>

 </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default PlacedOrder;
